import { render, staticRenderFns } from "./AddWifi.vue?vue&type=template&id=971ba264&"
import script from "./AddWifi.vue?vue&type=script&lang=js&"
export * from "./AddWifi.vue?vue&type=script&lang=js&"
import style0 from "./AddWifi.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports